import { DocumentoType, PlanoDocumentoField, PlanoType } from "../../db/Orm"
import DocumentFileUpload from "./DocumentFileUpload"
import { PiFile } from "react-icons/pi"
import { RefObject, useEffect, useState } from "react"
import API from "../../api/API"
import { Button } from "primereact/button"
import axios from "axios"
import { ProgressSpinner } from "primereact/progressspinner"
import { Document, Page } from "react-pdf"
import { BlockUI } from "primereact/blockui"
import { Toast } from "primereact/toast"

type LoadedFilesType = Partial<Record<PlanoDocumentoField, null|{url: string, file:File}>>
type DocumentoAntecipacaoProps = {
    antecipacao: PlanoType
    carregarPlanos: ()=>Promise<void>|(()=>void)
    documentoField: PlanoDocumentoField
    tipoDocumento: DocumentoType
    initialFile: File|null|undefined
    setInitialFile: (file:File|null|undefined)=>void
    permitirEnvio: boolean
    loadedFiles?: LoadedFilesType
    toastRef?: RefObject<Toast>
}
const download = (blobUrl?: string, filename?: string) => {
    if (!blobUrl) return
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename||'file.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
export const DocumentoAntecipacao = (props: DocumentoAntecipacaoProps)=>{
    const [fileSelect, setFileSelect] = useState<File|null>(null)
    const [blobUrl, setBlobUrl] = useState<string>()
    const [enviandoDocumento, setEnviandoDocumento] = useState<boolean>(false)
    const carregarDocumento = async()=>{
        const documentoUrl:string|null = props.antecipacao[props.documentoField]
        if (!documentoUrl) return
        const loadedFile = props.loadedFiles?.[props.documentoField]
        if (loadedFile?.url === documentoUrl){
            props.setInitialFile(loadedFile.file)
            setBlobUrl(URL.createObjectURL(loadedFile.file))
            return
        }
        await axios.get(documentoUrl, {responseType: 'blob'}).then((response)=>{
            const file = new File([response.data], response.config.url?.split('/').pop()||'file', {type: response.data.type})
            props.setInitialFile(file)
            setBlobUrl(URL.createObjectURL(file))
            if (props.loadedFiles){
                props.loadedFiles[props.documentoField] = {url: documentoUrl, file: file}
            }
            // console.log('Requerimento carregado', file)
        }).catch((err)=>{
            console.error(err)
        })
    }
    useEffect(()=>{
        if (props.initialFile) {
            setBlobUrl(URL.createObjectURL(props.initialFile))
            return
        }
    }, [])
    useEffect(()=>{
        return ()=>{
            if (blobUrl) URL.revokeObjectURL(blobUrl)
        }
    }, [])
    useEffect(()=>{
        if (props.initialFile !== undefined) return
        if (blobUrl) {
            URL.revokeObjectURL(blobUrl)
        }
        carregarDocumento()
    }, [props.initialFile])
    const enviarDocumento = async ()=>{
        const antecipacaoId = props.antecipacao.id
        if (antecipacaoId === null) {
            console.error('ID da antecipiação ausente!')
            return
        }
        if (!fileSelect) {
            console.error('Nenhum arquivo selecionado')
            return
        }
        setEnviandoDocumento(true)
        const response = await API.enviarDocumentoPlano(antecipacaoId, props.documentoField, fileSelect)
        if (response instanceof Error){
            console.error('Erro ao enviar documento', response)
            props.toastRef?.current?.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao enviar documento' })
        } else {
            await props.carregarPlanos()
            props.toastRef?.current?.show({ severity: 'success', summary: 'Sucesso', detail: 'Documento enviado com sucesso!' })
            setFileSelect(null)
            if (props.loadedFiles){
                props.loadedFiles[props.documentoField] = null
            }
        }
        setEnviandoDocumento(false)
    }
    const visualizacaoDocumentoTemplate = ()=>{
        return <div className='flex-column' >
            {props.initialFile===undefined && <>
                <h3>Carregando documento</h3>
                <ProgressSpinner/>
            </>}
            {props.initialFile instanceof File && <>
                <h3>Visualização do {props.tipoDocumento}</h3>
                <a href={blobUrl} target="_blank" rel="noopener noreferrer" className='document-border' >
                    <Document file={props.initialFile} >
                        <Page pageNumber={1} width={400} />
                    </Document>
                </a>
                <Button label="Download" icon="pi pi-download" onClick={()=>download(blobUrl, `${props.documentoField}_antecipacao_${props.antecipacao.id}.pdf`)} />
            </>}
        </div>
    }
    const envioDocumentoTemplate = ()=>{
        const headerText = props.antecipacao[props.documentoField] ? 'Substituir' : 'Enviar'
        return <div className='flex-column' >
            <h3>{headerText} {props.tipoDocumento}</h3>
            <BlockUI blocked={enviandoDocumento} containerClassName='flex-column'
                template={<ProgressSpinner style={{ backgroundColor: '#FFF', borderRadius: '6px' }}/>} >
                <DocumentFileUpload label='Carregar arquivo' icon={<PiFile/>} onFileSelect={setFileSelect} editMode />
                <Button label="Enviar" disabled={!fileSelect || enviandoDocumento} onClick={()=>enviarDocumento()} />
            </BlockUI>
        </div>
    }
    return <>
        {props.antecipacao[props.documentoField] && visualizacaoDocumentoTemplate()}
        {props.permitirEnvio !== false && envioDocumentoTemplate()}
    </>
}